import * as React from "react";
function LandscapeIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "50px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12v9.75a.75.75 0 0 1-.75.75H2.25a.75.75 0 0 1-.75-.75V2.25a.75.75 0 0 1 .75-.75h19.5a.75.75 0 0 1 .75.75zm1.5 0V2.25A2.25 2.25 0 0 0 21.75 0H2.25A2.25 2.25 0 0 0 0 2.25v19.5A2.25 2.25 0 0 0 2.25 24h19.5A2.25 2.25 0 0 0 24 21.75zM5.85 17.7l3.462-4.616a.75.75 0 0 1 1.13-.08l1.028 1.026a.75.75 0 0 0 1.13-.08l3.3-4.4a.75.75 0 0 1 1.2 0l2.67 3.56a.75.75 0 1 0 1.2-.9L18.3 8.65a2.248 2.248 0 0 0-3.6 0l-3.3 4.4 1.13-.08-1.027-1.027a2.25 2.25 0 0 0-3.391.242L4.65 16.8a.75.75 0 1 0 1.2.9M7.5 6.375a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0m1.5 0a2.625 2.625 0 1 0-5.25 0 2.625 2.625 0 0 0 5.25 0M.75 18h22.5a.75.75 0 0 0 0-1.5H.75a.75.75 0 0 0 0 1.5"
  }));
}
export default LandscapeIcon;